import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';

import ShopPageErrorBoundary from "../ShopPage/ShopPageErrorBoundary";
import WithCart from "../Cart/WithCart";
import Products from '../Products/index';

import GiftCard from '../GiftCard/index.jsx';

function GiftcardPage(props){

  if( props.nullClient === true ){

    // it needs some time bc its loading async from local storage
    // show this thing for a sec

    return (<div className="row product-shim-loading-cont">
           <div className="shim-cont">
             <div className="shim-wrapper">
                <div className="shim-box shimmer-animate"></div>
                <div className="shim-box shimmer-animate"></div>
                <div className="shim-box shimmer-animate"></div>
             </div>
           </div>
        </div>);
  }else{

    return (
      <Products>
        {props => (
          <GiftCard {...props}/>
        )}
      </Products>
   );
  }
}

function ShopPageWithErrorBoundary(props){

  return (<ShopPageErrorBoundary>
    <WithCart {...props}>
      <GiftcardPage {...props} />
    </WithCart>
  </ShopPageErrorBoundary>)
}

export default ShopPageWithErrorBoundary;
